import React from 'react';
import UnifiedRecordForm from '../components/CombinedRecord';
import Navbar from '../components/Navbar';

const DataInput: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-1 container max-w-(--breakpoint-lg) mx-auto px-4 py-1 shadow-md">
        {/* <div className="bg-white rounded-lg shadow-md p-2"> */}
          <UnifiedRecordForm />
        {/* </div> */}
      </main>
    </div>
  );
};

export default DataInput;
